// web/src/screens/Requests.tsx — every Request (run) across the workspace, newest-first (D06 A5).
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { PageHeader } from '../components/PageHeader';
import { AsyncBoundary } from '../components/AsyncBoundary';
import { Skeleton } from '../components/Skeleton';
import { RequestCard } from '../components/RequestCard';
import { Icon } from '../components/Icon';

export function Requests() {
  const nav = useNavigate();
  const q = useQuery({ queryKey: ['requests'], queryFn: () => api.listRequests() });
  const newBtn = (
    <button onClick={() => nav('/request')}
      className="inline-flex min-h-11 items-center gap-2 rounded-md bg-run px-4 font-medium text-runink transition-transform active:scale-[0.98]">
      <Icon name="plus" size={16} />Ask for a change
    </button>
  );
  return (
    <>
      <PageHeader title="Requests" subtitle="Every change you've asked for, across your sites." action={newBtn} />
      <AsyncBoundary query={q} skeleton={<Skeleton variant="row" count={4} />}
        isEmpty={(r) => r.length === 0}
        empty={{ icon: 'inbox', title: 'No requests yet', body: 'Want something changed on your site? Ask here and we will show you a preview first.', cta: { label: 'Ask for a change', onClick: () => nav('/request') } }}>
        {(rows) => <div className="flex flex-col gap-3">{rows.map((r) => <RequestCard key={r.id} run={r} />)}</div>}
      </AsyncBoundary>
    </>
  );
}
